/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardTopEntryResponse
 */
export interface LeaderboardTopEntryResponse {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardTopEntryResponse
     */
    rank: number;
    /**
     * Omitted on the public detail endpoint's snapshot fallback for every row except the authenticated caller's own (userId-enumeration redaction). Present on live topEntries.
     * @type {string}
     * @memberof LeaderboardTopEntryResponse
     */
    userId?: string;
    /**
     * True when this row is the authenticated caller. Set by the detail endpoint's snapshot fallback so the UI can highlight "you" without a userId.
     * @type {boolean}
     * @memberof LeaderboardTopEntryResponse
     */
    isMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardTopEntryResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardTopEntryResponse
     */
    avatarUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardTopEntryResponse
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardTopEntryResponse
     */
    eventCount: number;
}

/**
 * Check if a given object implements the LeaderboardTopEntryResponse interface.
 */
export function instanceOfLeaderboardTopEntryResponse(value: object): value is LeaderboardTopEntryResponse {
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('eventCount' in value) || value['eventCount'] === undefined) return false;
    return true;
}

export function LeaderboardTopEntryResponseFromJSON(json: any): LeaderboardTopEntryResponse {
    return LeaderboardTopEntryResponseFromJSONTyped(json, false);
}

export function LeaderboardTopEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardTopEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'isMe': json['isMe'] == null ? undefined : json['isMe'],
        'displayName': json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'value': json['value'],
        'eventCount': json['eventCount'],
    };
}

export function LeaderboardTopEntryResponseToJSON(json: any): LeaderboardTopEntryResponse {
    return LeaderboardTopEntryResponseToJSONTyped(json, false);
}

export function LeaderboardTopEntryResponseToJSONTyped(value?: LeaderboardTopEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'userId': value['userId'],
        'isMe': value['isMe'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'value': value['value'],
        'eventCount': value['eventCount'],
    };
}

